/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Button, message, Drawer, DatePicker, Form } from 'antd'
import Checkbox from '../../../../components/Custom/CustomCheckbox'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

const { RangePicker } = DatePicker
// const dateFormat = 'YYYY/MM/DD'
const dateFormat = 'LL'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { form, AuthStore, saveBarangayTerm, onClose, isEdit, selectedBarangayTerm } = this.props
		const { barangay_uid } = AuthStore
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}

			const startDate = moment(values.barangay_term[0]).format('YYYY-MM-DD')
			const endDate = moment(values.barangay_term[1]).format('YYYY-MM-DD')
			let params = {
				barangay_uid,
				start_date: startDate,
				end_date: endDate
			}
			if (isEdit && selectedBarangayTerm) {
				params = Object.assign({}, params, { barangay_term_uid: selectedBarangayTerm.uid })
			}
			console.log('params', params)

			message.loading({ key: 'set_brgy_term', content: 'Saving Barangay Term, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveBarangayTerm(params).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_brgy_term', content: 'Barangay term successfully saved.' })

					//create audit trail
					const auditParams = {
						module_name: 'Utilities',
						action: (isEdit && selectedBarangayTerm) ? 'Update' : 'Create',
						message: (isEdit && selectedBarangayTerm) ? 
							`Update barangay term ${params.start_date} to ${params.end_date}` : 
							`Created new barangay term ${params.start_date} to ${params.end_date}`
					}
					AuthStore.saveAuditTrail(auditParams)
					
					window.location.reload()
					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving barangay term')
					message.error({ key: 'set_brgy_term', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	render() {
		const { visible, onClose, form, selectedBarangayTerm } = this.props
		const { getFieldDecorator } = form
        
		return (
			<Drawer
				title="Add Barangay Terms"
				placement="right"
				// closable={false}
				onClose={onClose}
				visible={visible}
				width={'35%'}
				bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
			>
				<Form onSubmit={this.handleSubmit}>
					<Row>
						<Form.Item label='Select Date Range of Term'>
							{ getFieldDecorator('barangay_term', {
								initialValue: (selectedBarangayTerm) ? 
								    [moment(new Date(selectedBarangayTerm.start_date), dateFormat), moment(new Date(selectedBarangayTerm.end_date), dateFormat)] : 
								    [moment(new Date(), dateFormat), moment(new Date(), dateFormat)],
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<RangePicker 
									format={dateFormat}
									separator='to'
									style={{ width: '100%' }}
								/>
							)}
						</Form.Item>
					</Row>
					{
						selectedBarangayTerm &&
						<Row>
							<Form.Item label=''>
								{ getFieldDecorator('is_active', {
									initialValue: _.isEqual(selectedBarangayTerm.is_active, 1) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>Is Active?</Checkbox>
								)}
							</Form.Item>
						</Row>
					}
				</Form>
				<div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div>
			</Drawer>
		)
	}
}

const SET_BARANGAY_TERM = gql`
    mutation setBarangayTerm($input: JSON) {
		setBarangayTerm(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-barangay-term' }),
	inject('AuthStore'),
	graphql(SET_BARANGAY_TERM, {
		props({ mutate }) {
			return {
				saveBarangayTerm(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangayTerms']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
